import React from 'react';

import { CrossIcon } from '@vlabs/icons';
import { SideMenu } from '@vlabs/uikit';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import st from './shared.module.sass';

export function FiltersHeader({
  onClick,
  customTitle = undefined,
  isAdaptive = false,
  mode = 'close',
  rightIcon = undefined,
}) {
  const { t } = useTranslation();

  // проп 'isAdaptive' — гибридный режим:
  // заголовок появляется только на экранах < 1920px

  // проп 'mode' у заголовка имеет два варианта
  // close - иконка крестик справа для закрытия панели
  // goBack - иконка стрелки слева для возвращенния на шаг назад
  const shouldGoBack = mode === 'goBack';
  const shouldClosePanel = mode === 'close';
  let headerRightIcon = rightIcon;

  if (shouldClosePanel) {
    headerRightIcon = (
      <CrossIcon
        data-testid="closeFiltersButton"
        onClick={onClick}
      />
    );
  }

  return (
    <div className={st.FiltersHeader}>
      <div
        className={cn({
          [st.FiltersHeader_isAdaptive]: isAdaptive,
        })}
      >
        <SideMenu.MenuTitle
          onBackButtonClick={shouldGoBack ? onClick : undefined}
          rightIcon={headerRightIcon}
          value={customTitle || t('фильтры')}
        />
        <div className={st.Divider} />
      </div>
    </div>
  );
}

FiltersHeader.propTypes = {
  onClick: PropTypes.func.isRequired,
  customTitle: PropTypes.string,
  mode: PropTypes.oneOf(['close', 'goBack']),
  isAdaptive: PropTypes.bool,
  rightIcon: PropTypes.node,
};
